import { BoxProps } from "@shopify/restyle";
import { MotiView } from "moti";
import React from "react";

import { Theme } from "../../../theme/restyle/theme";
import { Box } from "../../primitive";

export type SkeletonLoaderProps = {
  testID?: string;
} & {
  [K in keyof Pick<
    BoxProps<Theme>,
    | "p"
    | "px"
    | "py"
    | "pt"
    | "pb"
    | "pl"
    | "pr"
    | "paddingLeft"
    | "paddingRight"
    | "paddingTop"
    | "paddingBottom"
    | "m"
    | "mx"
    | "marginHorizontal"
    | "my"
    | "marginVertical"
    | "mt"
    | "mb"
    | "ml"
    | "mr"
    | "marginTop"
    | "marginBottom"
    | "marginLeft"
    | "marginRight"
    | "width"
    | "height"
    | "flex"
    | "borderRadius"
    | "borderBottomLeftRadius"
    | "borderBottomRightRadius"
    | "borderTopLeftRadius"
    | "borderTopRightRadius"
    | "minWidth"
    | "flexBasis"
  >]: BoxProps<Theme>[K];
};

export const SkeletonLoader = ({ testID, ...props }: SkeletonLoaderProps) => {
  return (
    <Box {...props} overflow="hidden" testID={testID ?? "skeleton-loader"}>
      <MotiView
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
        from={{
          backgroundColor: "#F7F7F7",
        }}
        animate={{
          backgroundColor: "#EDEDED",
        }}
        transition={{
          backgroundColor: {
            type: "timing",
            duration: 1000,
            loop: true,
          },
        }}
      />
    </Box>
  );
};
